import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = usePublishTradingOfferModal();

  const buttonLabel =
    data.modalActionType === actionTypes.EDIT
      ? t('EditOffer')
      : t('PublishOffer');

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  return (
    <>
      {!isReadOnlyView && (
        <Modal.Footer>
          <Button
            onClick={actions.handlePublishTradingOffer}
            disabled={!data.isTermsAndConditionsAccepted}
            lgSize
          >
            {buttonLabel}
          </Button>
        </Modal.Footer>
      )}
    </>
  );
};

export default PublishTradingOfferModalFooter;
